import { $fetch, $post } from '@/services/axios';

export function fetch(params) {
  return $fetch(`customer/orders`, params);
}

export const CUSTOMER_ORDER_CSV_URL = `customer/orders/csv`;

